export default {
    path: '/404',
    name: 'page-not-found',
    component: () => import('source/pages/auth/NotFoundPage.vue'),
    meta: {
        title: 'HQZen',
        canDisplayGlobalModals: false
    },
};
